import "./style.css";
import { FC, useState } from "react";
import { Grid, Toolbar } from "@mui/material";
import ToggleSwitch from "../../../../../shared/components/switch";
import TwoFactorAuthentication from "./twoFactorAuthentication";
import OtpForm from "./otpForm";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { TwoFactorAuthantication } from "../../../../../shared/interfaces/two-factor-authantication";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { FormProfileContainer } from "../../../../../shared/components/formProfileContainer";

const TwoFactorAuth: FC = () => {
  const { modifyData } = useMutation();
  const [verificationStatus, setVerficationStatus] = useState<boolean>(false);

  const toggleDisableStatus = async () => {
    setVerficationStatus((prev) => !prev);
    if (
      TwoFactorAuthanticationData.twoFactorAuthFlag &&
      TwoFactorAuthanticationData.twoFactorToken != null
    ) {
      await modifyData(`admin/two-factor-auth/generateDisableOtp`, "put");
    }
  };

  const { data, fetchData } = useQuery(`admin/two-factor-auth`, null);
  const TwoFactorAuthanticationData: TwoFactorAuthantication =
    (data as any)?.data || {};
  return (
    <>
      {!verificationStatus && (
        <FormProfileContainer>
          <Toolbar sx={{ justifyContent: "start" }}>
            <span>{"Two-Factor Authentication"}</span>
            <div>{}</div>

            <Grid item xs={2}>
              <ToggleSwitch
                status={TwoFactorAuthanticationData.twoFactorAuthFlag}
                handleChange={toggleDisableStatus}
              />
            </Grid>
          </Toolbar>
        </FormProfileContainer>
      )}
      {TwoFactorAuthanticationData.twoFactorAuthFlag &&
        TwoFactorAuthanticationData.twoFactorToken != null &&
        verificationStatus && (
          <OtpForm
            setVerficationStatus={setVerficationStatus}
            twoFactorAuthFlag={TwoFactorAuthanticationData.twoFactorAuthFlag}
            fetchData={fetchData}
            userEmail={TwoFactorAuthanticationData?.user?.email}
          />
        )}
      {!TwoFactorAuthanticationData.twoFactorAuthFlag && verificationStatus && (
        <TwoFactorAuthentication
          setVerficationStatus={setVerficationStatus}
          twoFactorAuthFlag={TwoFactorAuthanticationData.twoFactorAuthFlag}
          fetchData={fetchData}
          userEmail={TwoFactorAuthanticationData?.user?.email}
        />
      )}
    </>
  );
};
export default TwoFactorAuth;
